import { Component, ElementRef, OnInit, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { VideoService } from "../video.service";
import { Router } from "@angular/router";
import { Vehicule } from "../../../model/data-managemnt";
import { DataManagementService } from "../../data-management/data-management.service";
import { SigninService } from "../../../signin/signin.service";

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})


export class VideoComponent implements OnInit, OnDestroy {
  @ViewChild('remote_video', { static: true }) videoElementRef: ElementRef;
  vehicule: Vehicule;

  constructor(
    public videoService: VideoService,
    public signinService: SigninService,
    public dataManagementService: DataManagementService,
    private router: Router,
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.queryParams) {
      try {
        const vehicleData = JSON.parse(navigation.extras.queryParams['type']);
        console.log("Vehicle data from navigation:", vehicleData);
      } catch (error) {
        console.error("Error parsing vehicle data:", error);
        this.videoService.displayStatus("Error loading vehicle data", 'error');
      }
    }

    this.vehicule = this.dataManagementService.selectedVehicule;
    console.log("Selected vehicle:", this.vehicule);
  }

  ngOnInit() {
    if (!this.vehicule) {
      this.videoService.displayStatus("No vehicle selected", 'warning');
      this.router.navigate(['client']);
      return;
    }

    this.videoService.remoteVideo = this.videoElementRef;

    if (this.videoService.connexion) {
      this.videoService.disconnectSocket(this.vehicule);
    }

    this.cancelCountdown();
  }

  ngOnDestroy() {
    this.performEmergencyCleanup();
  }

  handleHangup() {
    try {
      if (this.videoService.stream || this.videoService.playback) {
        this.videoService.hangUpCall(this.vehicule);
      }

      this.videoService.createPeerConnection();
      this.videoService.resetService();

      // this.toastr.success("Disconnected successfully", "Video Stream");
    } catch (error) {
      console.error("Error during hangup:", error);
      // this.toastr.error("Error disconnecting", "Video Stream");
    }
    this.router.navigate(['client']);
  }

  cancelCountdown() {
    this.videoService.counterLoading = false;
    this.videoService.counter = 0;
  }

  cleanup() {
    this.videoService.disconnectSocket(this.vehicule);
    if (this.videoElementRef?.nativeElement) {
      this.videoElementRef.nativeElement.srcObject = null;
    }
    this.videoService.resetService();
  }

  close() {
    this.performEmergencyCleanup();
    this.router.navigate(['client']);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.performEmergencyCleanup();
    return "Are you sure you want to leave?";
  }

// Monitor visibility changes (tab minimized, switched to another tab)
  @HostListener('window:visibilitychange', ['$event'])
  visibilityChangeHandler() {
    if (document.visibilityState === 'hidden') {
      console.log('App visibility changed to hidden - launching full cleanup');
      this.performEmergencyCleanup();
    }
  }

// Monitor when window loses focus (user clicked away from app)
  @HostListener('window:blur', ['$event'])
  windowBlurHandler() {
    console.log('Window lost focus - launching full cleanup');
    this.performEmergencyCleanup();
  }

// Monitor page hide event (mobile browser in background, app switching)
  @HostListener('window:pagehide', ['$event'])
  pageHideHandler() {
    console.log('Page hide event detected - launching full cleanup');
    this.performEmergencyCleanup();
  }

// Monitor app state changes (for mobile PWAs and some browsers)
  @HostListener('window:freeze', ['$event'])
  pageFreezeHandler() {
    console.log('Page freeze event detected - launching full cleanup');
    this.performEmergencyCleanup();
  }

  private performEmergencyCleanup() {
    console.log('Emergency cleanup triggered');
    try {
      if (this.videoService.stream || this.videoService.playback) {
        this.videoService.sendMessage({
          event: "message",
          data: {
            source: this.videoService.myUsername,
            target: this.videoService.vehicule?.device?.streamId,
            type: "hang-up"
          }
        });
      }

      this.videoService.peerConnection?.close();
      this.videoService.socket$?.complete();
    } catch (e) {
      console.error('Error during emergency cleanup', e);
    }

    this.cleanup();
  }
}
